import React from 'react';
import PropTypes from 'prop-types';

import { sciFormatted } from '../../../utils/formatting';
import BlockLabel from './block-label';

const leftAlign = {
  textAlign: 'left',
  margin:5
};

const padding20 = {
  padding: 20,
  height: 150,
};

const Followers = props => {
  const { profile } = props;
  const { instagramCount } = profile;
  return (
    <div style={padding20}>
      <h2 style={leftAlign}>{sciFormatted(instagramCount)}</h2>
      <h5 style={leftAlign}>185 Posts ***</h5>
      <h5 style={leftAlign}>Active Since 2016</h5>
      <BlockLabel label="Followers" />
    </div>
  );
};

Followers.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default Followers;



// WEBPACK FOOTER //
// ./src/containers/summary/components/followers.js